import SearchInput from './components/search-input';
import google from './components/providers/google.js';
import semshopping from './components/providers/semshopping.js';
import sem from './components/providers/sem.js';
import dropDownSearch from './components/drop-down-search';
import serpSwitcher from './components/serp-switcher';
import definition from './intl.json';
import intl from 'preact-i18n';

function wrap(Child) { return intl(Child, { scope: 'search',definition }); }


export default wrap(SearchInput);
export const DropDownSearch = wrap(dropDownSearch);
export const Google = wrap(google);
export const SemShopping = wrap(semshopping);
export const Sem = wrap(sem);
export const SerpSwitcher = wrap(serpSwitcher);
